<body>
    <div class="full_height">
        <mat-drawer-container>
            <mat-drawer mode="side" opened="true">
                <app-sidebar></app-sidebar>
            </mat-drawer>
            <mat-drawer-content>
                <app-header></app-header>
                <router-outlet></router-outlet>
            </mat-drawer-content>
        </mat-drawer-container>    
    </div>
</body>
